 
(function () {
  'use strict';

  var OFFSET_VAR = '--swiper-navigation-top-offset';
  var READY_CLASS = 'has-media-centered-nav';
  var observers = [];
 
  function isCardMediaSwiper(el) {
    return el.classList.contains('product-card__swiper');
  }

  function findMedia(el) {
    var slide = el.querySelector('.swiper-slide');
    return slide ? slide.querySelector('.product-card__media') : null;
  }

  function alignNavToMedia(el) {
    if (!el || isCardMediaSwiper(el)) return;

    var media = findMedia(el);
    if (!media) return;  

    var height = media.offsetHeight;
    if (!height) return; 

    el.style.setProperty(OFFSET_VAR, height / 2 + 'px');
    el.classList.add(READY_CLASS);
  }

  function carousels(root) {
    var scope = root || document;
    return Array.prototype.filter.call(
      scope.querySelectorAll('.swiper'),
      function (el) {
        return !isCardMediaSwiper(el) && findMedia(el);
      }
    );
  }

  function observe(el) {
    if (typeof ResizeObserver === 'undefined') return;

    var media = findMedia(el);
    if (!media) return;

    var ro = new ResizeObserver(function () {
      alignNavToMedia(el);
    });
    ro.observe(media);
    observers.push({ el: el, ro: ro });
  }

  function unobserve(root) {
    observers = observers.filter(function (entry) {
      if (root && !root.contains(entry.el)) return true;
      entry.ro.disconnect();
      return false;
    });
  }

  function refresh(root) {
    carousels(root).forEach(function (el) {
      alignNavToMedia(el);
      observe(el);
    });
  }

  /* Fallback for browsers without ResizeObserver. */
  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      carousels().forEach(alignNavToMedia);
    }, 150);
  }

  function init() {
    refresh(document);
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', onResize);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Images settle late under the "adapt" ratio — re-measure once everything loads.
  window.addEventListener('load', function () {
    refresh(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    refresh(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    unobserve(event.target);
  });
})();
